// This file contains the session keys used in the application.
export const SESSION_KEYS = {
    SEATING_SEATS: 'SEATING_SEATS',
    SLEEPING_SEATS: 'SLEEPING_SEATS',
    TOTAL_PRICE: 'TOTAL_PRICE',
    FROM_LOCATION: 'FROM_LOCATION',
    TO_LOCATION: 'TO_LOCATION',
    FROM_LOCATION_CODE: 'FROM_LOCATION_CODE',
    TO_LOCATION_CODE: 'TO_LOCATION_CODE',
}